"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sortNumeric = function (a, b) { return a - b; };
exports.getSortedKeyframes = function (propertyGroup) {
    return Object.keys(propertyGroup).map(Number).sort(sortNumeric);
};
//# sourceMappingURL=KeyframeUtils.js.map